import { useState, useEffect, useRef, lazy, Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
// import { MainNavigation } from "../Navigation/MainNavigation";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// const Home = lazy(() => import("../Pages/home/home"));
// const Gallery = lazy(() => import("../Pages/gallery/Gallery"));
// const Rm = lazy(() => import("../Pages/Rick-and-Morty/index"));
// const Vote = lazy(() => import("../Pages/Vote/vote"));
// const Layout = lazy(() => "../Layout/Layout");

import { Home } from "../Pages/home/home";
import Gallery from "../Pages/gallery/Gallery";
import Rm from "../Pages/Rick-and-Morty/index";
import Vote from "../Pages/Vote/vote";
import { Layout } from "../Layout/Layout";

// import { About } from "../Pages/about/about.js";
gsap.registerPlugin(ScrollTrigger);

export const Router = ({ mediaBreakPoint }) => {
	// let [] = useOutletContext();
	// console.log(useOutletContext);
	// const [count, setCount] = useOutletContext();
	// const [hasMaxWidth900, setHasMaxWidth] = useOutletContext();

	// useEffect(() => {
	// 	console.log(hasMaxWidth900);
	// }, [hasMaxWidth900]);

	//which page is active
	const location = useLocation();
	const [displayLocation, setDisplayLocation] = useState(location);

	const frontPageScrollTrigger = useRef(null);

	// useEffect(() => {
	// 	//if (frontPageScrollTrigger !== undefined) {
	// 	console.log(frontPageScrollTrigger);
	// 	// }
	// });

	// the page changes
	useEffect(() => {
		if (location !== displayLocation) {
			ScrollTrigger.getAll().forEach((ST) => {
				ST.kill();
			});
			setDisplayLocation(location);
		}
		// console.log(displayLocation);
	}, [location, displayLocation]);

	// const [siteLoad, setSiteLoad] = useState(true);

	// useEffect(() => {
	// 	setSiteLoad(false);
	// 	return () => {
	// 		setSiteLoad(true);
	// 		//console.log("site cleanUp");
	// 	};
	// }, [siteLoad]);

	let siteLoad = useRef(true);

	const NoMatch = () => {
		return <p>Top side: 404!</p>;
	};
	const mainWrapper = useRef(null);
	const body = useRef(document.querySelector("body"));

	// useEffect(() => {
	// 	console.log(location);
	// }, [location]);

	useEffect(() => {
		if (location.pathname === "/Gallery") {
			mainWrapper.current.className = "gallery-main-wrapper";
		} else {
			if (mainWrapper.current.classList.contains("gallery-main-wrapper")) {
				mainWrapper.current.classList.remove("gallery-main-wrapper");
			}
			if (body.current.classList.contains("locked")) {
				body.current.classList.remove("locked");
			}
		}
	}, [location]);

	return (
		<div id='main-wrapper' ref={mainWrapper}>
			<div id='main'>
				{/* <Suspense fallback={<div>Loading...</div>}> */}
				<Routes location={displayLocation}>
					<Route exact path='/' element={<Layout mediaBreakPoint={mediaBreakPoint} />}>
						<Route exact index element={<Home title='home' siteLoad={siteLoad} id={"home"} />}></Route>
						<Route
							exact
							path='/Gallery'
							element={
								<Gallery
									title='Gallery'
									frontPageScrollTrigger={frontPageScrollTrigger}
									id={"gallery"}
									mainWrapper={mainWrapper}
								/>
							}
						></Route>
						<Route exact path='/RM' element={<Rm title='Rick and morty' id='rm' />}></Route>
						<Route exact path='/Vote' element={<Vote title='Vote' id='vote' />}></Route>
						{/* <Route exact path="/About" element={<About title="About" />}></Route> */}
						<Route path='*' element={<NoMatch />} />
					</Route>
				</Routes>
				{/* </Suspense> */}
			</div>
		</div>
	);
};
